import React from 'react';
import DOMPurify from "dompurify";

class JobSocialShares extends React.Component {

  render() {
    const props_obj = this.props;
    const social_obj = props_obj.social_data;
    const channel = [];
    var query_parts = "";

      /**
       * Convert title to the slug.
       *
       * @param {string} title Post title.
       *
       * @return {string}
       */
      function convertToSlug( title ) {

          return title.toLowerCase().replace( / /g,'-' ).replace( /[^\w-]+/g,'' );
      }

    const postlink = "https://" + window.location.hostname + "/jobs/" + this.props.job_data._id + "/" + convertToSlug( this.props.job_data.title ) + "/"; // phpcs:ignore WordPressVIPMinimum.JS.Window.location

    if (social_obj !== undefined && social_obj !== null && Object.keys(social_obj).length > 0) {
      return (
        <div className="col-lg-1 job-social-icons">
            <nav className="article-social">
                {
                  Object.keys(social_obj).forEach(function(key) {

                    if(social_obj[key].param2 !== ''){
                        query_parts = '&' + social_obj[key].param2 + '=' + encodeURIComponent( props_obj.job_data.title );
                    }

                    const url = social_obj[key].url + "?" + social_obj[key].param1 +"=" + postlink + query_parts;

                      channel.push(
                        <li>
                            <a className={`icon-${key}`} href={ social_obj[key].url + '?' + social_obj[key].param1 + '=' + postlink + query_parts} target="_blank" rel="noreferrer" title="Opens in a new window" onClick={(e) => {
                              e.preventDefault();
                              const width = 600;
                              const height = 400;
                              const left = (window.innerWidth - width) / 2;
                              const top = (window.innerHeight - height) / 2;
                              window.open(
                                url,
                                "Share",
                                `width=${width},height=${height},left=${left},top=${top}`
                              );
                            }}>
                            </a>
                        </li>
                      );
                  })
                }
                <ul className="social-nav">
                  {channel}
                </ul>
            </nav>
        </div>
      );
    } else {
      return (
        <div className="col-md-1"></div>
      );
    }
  }
}

export default JobSocialShares;
